import React from 'react';
import FilterGroupSearch from './FilterGroupSearch';

const SearchFilterGroupContainer = ({
  setTabValue,
  handleClose,
  setRecordFormatFilterGroupCode,
  setSelectedFilterGroupCode,
  setFilterGroupCode,
  setRecordFormatFilterGroupId,
  setIsCopyRowData,
}) => {
  return (
    <>
      <FilterGroupSearch
        setRecordFormatFilterGroupId={setRecordFormatFilterGroupId}
        setFilterGroupCode={setFilterGroupCode}
        setTabValue={setTabValue}
        setSelectedFilterGroupCode={setSelectedFilterGroupCode}
        handleClose={handleClose}
        setRecordFormatFilterGroupCode={setRecordFormatFilterGroupCode}
        setIsCopyRowData={setIsCopyRowData}
      />
    </>
  );
};
export default SearchFilterGroupContainer;
